import * as tslib_1 from "tslib";
import React from 'react';
import throttle from 'lodash.throttle';
import { AutoSizer, } from 'react-virtualized/dist/commonjs/AutoSizer';
import { MeasuredCookieConnector } from '../../../Measured';
var MeasuredToAutoSizer = /** @class */ (function (_super) {
    tslib_1.__extends(MeasuredToAutoSizer, _super);
    function MeasuredToAutoSizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onResizeCombined = throttle(function (size) {
            var _a = _this.props, _b = _a.shouldUpdateCookie, shouldUpdateCookie = _b === void 0 ? true : _b, updateCookie = _a.onUpdatedDims, onResize = _a.onResize;
            shouldUpdateCookie && updateCookie && updateCookie(size);
            onResize && onResize(size);
        }, 300);
        return _this;
    }
    MeasuredToAutoSizer.prototype.render = function () {
        var _a = this.props, defaultWidth = _a.defaultWidth, defaultHeight = _a.defaultHeight, prevLoadDims = _a.prevLoadDims, onUpdatedDims = _a.onUpdatedDims, shouldUpdateCookie = _a.shouldUpdateCookie, onResize = _a.onResize, children = _a.children, props = tslib_1.__rest(_a, ["defaultWidth", "defaultHeight", "prevLoadDims", "onUpdatedDims", "shouldUpdateCookie", "onResize", "children"]);
        return (React.createElement(AutoSizer, tslib_1.__assign({ defaultWidth: defaultWidth ||
                (prevLoadDims ? Number(prevLoadDims.width) : undefined), defaultHeight: defaultHeight ||
                (prevLoadDims ? Number(prevLoadDims.height) : undefined), onResize: this.onResizeCombined }, props), children));
    };
    return MeasuredToAutoSizer;
}(React.Component));
export { MeasuredToAutoSizer };
var MeasuredAutoSizer = MeasuredCookieConnector(MeasuredToAutoSizer);
MeasuredAutoSizer.displayName = 'MeasuredAutoSizer';
export default MeasuredAutoSizer;
//# sourceMappingURL=MeasuredAutoSizer.js.map